export enum FileTypeEnum {
  // EXCEL
  EXCEL = 0,

  // PDF
  PDF = 1,

  // JPG
  JPG = 2,

  // PNG
  PNG = 3,

  // GIF
  GIF = 4,

  // SVG
  SVG = 5,
}
